<header>
  <a class="logo" routerLink="/" aria-label="eazi Startseite">
    <span class="logo-mark" aria-hidden="true"></span>
    <span class="logo-text" aria-hidden="true">eazi</span>
  </a>

  <nav aria-label="Hauptnavigation">
    <ul class="menus">
      @for (menu of menus; track menu.id) {
        <li routerLinkActive #active="routerLinkActive">
          <button
            type="button"
            [attr.aria-expanded]="isOpen(menu.id)"
            [attr.aria-controls]="panelId(menu.id)"
            [attr.aria-current]="active.isActive ? 'true' : null"
            (click)="toggle(menu.id)"
          >
            <span class="tab-ring">
              <span class="tab-ring-inner">
                <span class="tab-label">{{ menu.label }}</span>
              </span>
            </span>
          </button>
          <ul class="panel" [id]="panelId(menu.id)" [hidden]="!isOpen(menu.id)">
            @for (entry of menu.entries; track entry.path) {
              <li>
                <a
                  [routerLink]="entry.path"
                  [attr.data-label]="entry.label"
                  routerLinkActive
                  #linkActive="routerLinkActive"
                  ariaCurrentWhenActive="page"
                  (click)="closeOnLinkClick($event)"
                  >{{ entry.label }}
                  @if (linkActive.isActive) {
                    <ez-icon name="check" />
                  }
                </a>
              </li>
            }
          </ul>
        </li>
      }
    </ul>
  </nav>

  <div class="end">
    <ng-content />
  </div>
</header>
